import '@app/App.css';
import { Dialog, DialogContent, DialogTrigger } from "@comps/ui/dialog";
import { getWsButtonStyle, TW_ObjectMenuItem, useHover } from "@utils/twClasses";
import { FolderPlus } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useModelStore } from "src/store";
import ViewFolderForm, { ViewFolderCreationHeader } from "./ViewFolderForm";

interface ObjectMenuAddFolderItemProps {
  objectKey: string;
  closeMenu: () => void;
}

/**
 * "Add a folder" item of the object menu. Folders are personal:
 * every workspace member can create their own, whatever their rights.
 */
function ObjectMenuAddFolderItem({ objectKey, closeMenu }: ObjectMenuAddFolderItemProps) {

  const { t } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const wsHoverColor = useModelStore(state => state.wsHoverColor);
  const buttonHover = useHover(getWsButtonStyle('transparent'), getWsButtonStyle(wsHoverColor));

  const folderCreated = () => {
    setIsDialogOpen(false);
    closeMenu();
  }

  function cancel(event: React.MouseEvent<HTMLButtonElement> | undefined) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setIsDialogOpen(false);
    closeMenu();
  }

  function click(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    event.stopPropagation();
    setIsDialogOpen(true);
  }

  function onOpenChange(open: boolean) {
    setIsDialogOpen(open);
    if (!open) {
      closeMenu();
    }
  }

  return (
    <Dialog open={isDialogOpen} onOpenChange={onOpenChange}>
      <DialogTrigger className={TW_ObjectMenuItem + ` ${objectKey === null ? "item-disabled" : ""}`} {...buttonHover} onClick={click}>
        <FolderPlus className="ObjectMenuItemIcon" />{t("folder.button.new.text")}
      </DialogTrigger>
      {/* Clicks bubble through the React portal up to the object row (which
          toggles its collapse): stop them at the dialog boundary */}
      <DialogContent onClick={(e) => e.stopPropagation()}>
        <ViewFolderCreationHeader />
        <ViewFolderForm objectKey={objectKey} parentPath={null} onDone={folderCreated} onCancel={cancel} />
      </DialogContent>
    </Dialog>
  )
}

export default ObjectMenuAddFolderItem;
